var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.597,
    height: 19.12,
    viewBox: "0 0 34.597 19.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#53b5e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1064 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1064 421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.872,42.664c-.311-.352-7.7-8.974-17.08-8.974s-16.77,8.622-17.08,8.974a.873.873,0,0,0,0,1.137c.311.387,7.7,9.009,17.08,9.009s16.77-8.622,17.08-8.974A.873.873,0,0,0,54.872,42.664Zm-17.08,8.388c-7.215,0-13.429-5.92-15.24-7.8,1.794-1.882,8.007-7.8,15.24-7.8s13.429,5.92,15.24,7.8C51.22,45.132,45.007,51.052,37.792,51.052Z",
    transform: "translate(-20.501 -33.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.536,41.63a4.906,4.906,0,1,0,4.906,4.906h0A4.918,4.918,0,0,0,46.536,41.63Zm0,8.054a3.148,3.148,0,1,1,3.148-3.148A3.147,3.147,0,0,1,46.536,49.684Z",
    transform: "translate(-29.245 -36.976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeNormal);
export default __webpack_public_path__ + "static/media/eye-normal.ad5e2c2be468f2e30a43f858274b8abc.svg";
export { ForwardRef as ReactComponent };